// Selection identifies one song or order only. Entitlements and issuance come from the authenticated API.
export function certificateSelection(query) {
  const value = key => typeof query[key] === 'string' ? query[key].trim() : '';
  const taskId = value('task_id');
  const musicId = value('music_id');
  const orderId = value('order_id');
  if (!orderId && !(taskId && musicId)) return null;
  return { taskId, musicId, orderId, cancelled: value('cancelled') === '1' };
}
